"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ReviewImageModalWrapper", {
  enumerable: true,
  get: function () {
    return _ReviewImageModalWrapper.ReviewImageModalWrapper;
  }
});
var _ReviewImageModalWrapper = require("./ReviewImageModalWrapper");
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJfUmV2aWV3SW1hZ2VNb2RhbFdyYXBwZXIiLCJyZXF1aXJlIl0sInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvUmV2aWV3cy9SZXZpZXdJbWFnZU1vZGFsV3JhcHBlci9pbmRleC50c3giXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHsgUmV2aWV3SW1hZ2VNb2RhbFdyYXBwZXIgfSBmcm9tIFwiLi9SZXZpZXdJbWFnZU1vZGFsV3JhcHBlclwiXG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7O0FBQUEsSUFBQUEsd0JBQUEsR0FBQUMsT0FBQSIsImlnbm9yZUxpc3QiOltdfQ==